import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Form, Checkbox } from 'antd';
import { Icon } from 'antd';
import moment from 'moment';
import { updateAppUser } from '@redux/appUsers/actions';
import './styles.less';
import { useDispatch } from 'react-redux';

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  layout: 'vertical',
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};

const VerificationModal = ({
  appUser,
  visible,
  onCancel,
  form: { getFieldDecorator, validateFields },
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleSubmit = () => {
    // e.preventDefault();
    validateFields((err, values) => {
      if (!err) {
        // debugger;
        dispatch(updateAppUser(appUser.uuid, {}, values.identityVerified));
        setTimeout(() => {
          onCancel();
        }, 500);
      }
    });
  };

  return (
    <Modal
      title={t('cards:PatientDetails.verificationModalTitle')}
      visible={visible}
      onCancel={() => {
        onCancel();
      }}
      onOk={handleSubmit}
      width={300}
      // footer={[
      //     <div className="footer-right" key="footer-button-add">
      //         <Button
      //             disabled={submitting}
      //             loading={submitting}
      //             type="primary"
      //             onClick={() => {
      //                 onSubmit();
      //             }}
      //         >
      //             {t('common:selectionModal.add')}
      //         </Button>
      //     </div>,
      // ]}
      className="verification-modal"
    >
      <div>
        <h2>
          <span class={`status ${appUser.identityVerified ? 'verified' : 'unverified'}`}>
            <Icon type="idcard" />
          </span>{' '}
          {t('cards:PatientDetails.identityVerification.title')}
        </h2>
        <Form layout={formItemLayout} className="detail-form" onSubmit={handleSubmit}>
          <p>{t('cards:PatientDetails.identityVerification.explanation1')}</p>
          <ul>
            <li>
              {t('cards:PatientEditDetails.firstName.label')}:{' '}
              <strong>{appUser.firstName || t('common:unknown')}</strong>
            </li>
            <li>
              {t('cards:PatientEditDetails.lastName.label')}:{' '}
              <strong>{appUser.lastName || t('common:unknown')}</strong>
            </li>
            <li>
              {t('cards:PatientEditDetails.dateOfBirth.label')}:{' '}
              <strong>
                {appUser.dateOfBirth
                  ? moment(appUser.dateOfBirth).format('LL')
                  : t('common:unknown')}
              </strong>
            </li>
          </ul>
          <Form.Item
          // key={'identityVerified'}
          // label={<>{t('cards:PatientDetails.identityVerification.fieldLabel')}</>}
          >
            {getFieldDecorator('identityVerified', {
              initialValue: appUser.identityVerified,
              rules: [{ required: false }],
            })(
              <Checkbox defaultChecked={appUser.identityVerified}>
                {t('cards:PatientDetails.identityVerification.checkboxLabel')}
              </Checkbox>,
            )}
          </Form.Item>
        </Form>
        <hr />
        <h2>
          <span class={`status ${appUser.emailVerified ? 'verified' : 'unverified'}`}>
            <Icon type="mail" />
          </span>{' '}
          {t('cards:PatientDetails.emailVerification.title')} &mdash;&nbsp;
          {appUser.emailVerified ? (
            <a href={`mailto:${appUser.email}`}>{appUser.email}</a>
          ) : (
            appUser.email
          )}
        </h2>
        <p>
          {t(
            `cards:PatientDetails.${
              appUser.emailVerified ? 'emailVerifiedPopover' : 'emailUnverifiedPopover'
            }.explanation1`,
          )}
        </p>
        <p>
          {t(
            `cards:PatientDetails.${
              appUser.emailVerified ? 'emailVerifiedPopover' : 'emailUnverifiedPopover'
            }.explanation2`,
          )}
        </p>
      </div>
    </Modal>
  );
};

VerificationModal.defaultProps = {
  appUser: null,
  visible: false,
  onCancel: () => {},
};

const WrappedVerificationModal = Form.create()(VerificationModal);

export default WrappedVerificationModal;
